"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CARD_TYPES = void 0;
var CARD_TYPES = exports.CARD_TYPES = {
  ctd: 'CHANGE_THE_DATE',
  dstd: 'DIGITAL_SAVE_THE_DATE',
  enclosure: 'ENCLOSURE',
  holiday: 'HOLIDAY',
  invitation: 'INVITATION',
  invitationEnvelope: 'INVITATION_ENVELOPE',
  menu: 'MENU',
  place: 'PLACE',
  tableNumber: 'TABLE_NUMBER',
  program: 'PROGRAM',
  rsvp: 'RSVP',
  rsvpEnvelope: 'RSVP_ENVELOPE',
  std: 'SAVE_THE_DATE',
  thankyou: 'THANK_YOU',
  weddingShower: 'WEDDING_SHOWER_INVITATION'
};